import React, { useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import {
  FaTruck,
  FaUsers,
  FaGlobe,
  FaStar,
  FaShieldAlt,
  FaClock,
  FaEuroSign,
  FaHandshake,
  FaTasks,
  FaTruckMoving,
  FaRegStar,
  FaBuilding,
  FaLightbulb,
  FaRegUser,
  FaLinkedinIn,
} from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./AboutUs.css";
import HeroSection from "../heroSection/HeroSection";
import heroPhoto from "../../assets/images/tra.jpg"; // غيرها بصورة الشاحنة البيضاء
import Footer from "../footer/Footer";
import { useTranslation } from "react-i18next";
import SEO from "../SEO";
import { MdMoneyOff, MdOutlineAttachMoney, MdOutlineStickyNote2 } from "react-icons/md";
import { AiOutlineFieldTime, AiOutlineSafety, AiOutlineSafetyCertificate } from "react-icons/ai";
import { IoChatbubblesOutline, IoTimeOutline } from "react-icons/io5";
import IMG_HERO_BG from "../../assets/images/assa.jpg";
import NavbarMenu from "../heroSection/NavbarMenu";
import { useNavigate } from "react-router-dom";
import { LuHandshake, LuNotebookPen, LuNotepadText } from "react-icons/lu";
import { TbCurrencyEuroOff, TbTruckReturn, TbWorld } from "react-icons/tb";
import { CiDeliveryTruck, CiGlobe } from "react-icons/ci";
import { FiUsers } from "react-icons/fi";
import { PiBuildings, PiCarProfileLight } from "react-icons/pi";
import TestimonialsSection from "../testimonialsSection/TestimonialsSection";
import ZaherImg from "../../assets/images/zaher.jpg";
import RashadImg from "../../assets/images/rashad.png";
import { RiLock2Fill, RiMoneyEuroCircleLine } from "react-icons/ri";
import { TiArrowDownOutline } from "react-icons/ti";


export default function AboutUs({
  showNavbar = true,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const trustBadges = [
    { 
      icon: <FaEuroSign />, 
      label1: t("aboutUsNew.hero.trust.label1")
    },
    { 
      icon: <AiOutlineSafety />, 
      label1: t("aboutUsNew.hero.trust.label2")
    },
    { 
      icon: <IoTimeOutline />, 
      label1: t("aboutUsNew.hero.trust.label3") 
    },
  ];

  const stats = [
    {
      icon: <TbTruckReturn size={32} className="text-orange mb-2" />,
      number: "10.000+",
      title: t("aboutUsNew.stats.transports")
    },
    {
      icon: <FiUsers size={32} className="text-orange mb-2" />,
      number: "200+",
      title: t("aboutUsNew.stats.partners")
    },
    {
      icon: <CiDeliveryTruck size={32} className="text-orange mb-2" />,
      number: "250+",
      title: t("aboutUsNew.stats.vehicles")
    },
    {
      icon: <TbWorld size={32} className="text-orange mb-2" />,
      number: "15+",
      title: t("aboutUsNew.stats.countries")
    },
    {
      icon: <FaRegStar size={32} className="text-orange mb-2" />,
      number: "98%",
      title: t("aboutUsNew.stats.satisfaction")
    }
  ];

  const timelineData = [
    { 
      icon: <PiCarProfileLight />,
      year: "2019",
      title: t("aboutUsNew.story.timeline.2019.title"), 
      text: t("aboutUsNew.story.timeline.2019.text"),
    },
    { 
      icon: <LuHandshake />,
      year: "2021",
      title: t("aboutUsNew.story.timeline.2021.title"),
      text: t("aboutUsNew.story.timeline.2021.text"),
    },
    { 
      icon: <TbWorld />,
      year: "2023",
      title: t("aboutUsNew.story.timeline.2023.title"),
      text: t("aboutUsNew.story.timeline.2023.text"),
    },
    { 
      icon: <PiBuildings />,
      year: "2025",
      title: t("aboutUsNew.story.timeline.2025.title"),
      text: t("aboutUsNew.story.timeline.2025.text"),
    },
    { 
      icon: <FaTruckMoving />,
      year: "Heute", 
      title: t("aboutUsNew.story.timeline.today.title"),
      text: t("aboutUsNew.story.timeline.today.text"),
    },
  ];

  const whySec = [
    { 
      icon: <AiOutlineSafetyCertificate />, 
      title: t("aboutUsNew.whyChoose.cards.title1"), 
      desc: t("aboutUsNew.whyChoose.cards.desc1") 
    },
    { 
      icon: <RiMoneyEuroCircleLine />, 
      title: t("aboutUsNew.whyChoose.cards.title2"), 
      desc: t("aboutUsNew.whyChoose.cards.desc2") 
    },
    { 
      icon: <AiOutlineFieldTime />, 
      title: t("aboutUsNew.whyChoose.cards.title3"), 
      desc: t("aboutUsNew.whyChoose.cards.desc3") 
    },
    { 
      icon: <FaRegUser />, 
      title: t("aboutUsNew.whyChoose.cards.title4"), 
      desc: t("aboutUsNew.whyChoose.cards.desc4" )
    },
    { 
      icon: <CiGlobe />, 
      title: t("aboutUsNew.whyChoose.cards.title5"), 
      desc: t("aboutUsNew.whyChoose.cards.desc5") 
    },
    { 
      icon: <AiOutlineSafetyCertificate />, 
      title: t("aboutUsNew.whyChoose.cards.title6"), 
      desc: t("aboutUsNew.whyChoose.cards.desc6" )
    },
  ];

  const valuesSec = [
    { 
      icon: <AiOutlineSafetyCertificate />, 
      title: t("aboutUsNew.values.items.title1"), 
      desc: t("aboutUsNew.values.items.desc1")
    },
    { 
      icon: <MdOutlineStickyNote2 />, 
      title: t("aboutUsNew.values.items.title2"), 
      desc: t("aboutUsNew.values.items.desc2") 
    },
    { 
      icon: <FaHandshake />, 
      title: t("aboutUsNew.values.items.title3"), 
      desc: t("aboutUsNew.values.items.desc3")
    },
    { 
      icon: <TiArrowDownOutline />, 
      title: t("aboutUsNew.values.items.title4"), 
      desc: t("aboutUsNew.values.items.desc4")
    },
  ];

  const testimonialsSec = [
    { 
      icon: <PiCarProfileLight />,
      stars: 5, 
      text: t("aboutUsNew.testimonials.items.text1"), 
      author: t("aboutUsNew.testimonials.items.author1")
    },
    { 
      icon: <IoChatbubblesOutline />,
      stars: 5, 
      text: t("aboutUsNew.testimonials.items.text2"), 
      author: t("aboutUsNew.testimonials.items.author2")
    },
    { 
      icon: <FaRegUser />,
      stars: 5, 
      text: t("aboutUsNew.testimonials.items.text3"), 
      author: t("aboutUsNew.testimonials.items.author3")
    },
  ];

  const ctaBadges = [
    { 
      icon: <IoTimeOutline />, 
      label1: t("aboutUsNew.cta.trust.label1")
    },
    { 
      icon: <TbCurrencyEuroOff />, 
      label1: t("aboutUsNew.cta.trust.label2")
    },
    { 
      icon: <RiLock2Fill />, 
      label1: t("aboutUsNew.cta.trust.label3") 
    },
  ];


  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <SEO
        title="TransCirox – Über uns | Ihre Transportplattform in Deutschland"
        description="Erfahren Sie mehr über TransCirox – die digitale Plattform für Umzug, Möbeltransport und Gütertransport in Deutschland. Unsere Mission und unser Team."
        keywords="TransCirox, Über uns, Transportplattform, Umzugsplattform, Transportfirma Deutschland, Möbeltransport"
      />

      {/* ── Original HeroSection (Navbar etc.) ── */}
      {showNavbar && <NavbarMenu />}

      {/* ════════════════════════════════════════
          HERO SECTION
      ════════════════════════════════════════ */}
      <section
        className="umzug-hero"
        style={{
          backgroundImage: `linear-gradient(to right, rgb(27 27 27 / 97%) 45%, rgb(51 51 51 / 55%) 70%, transparent 100%), url(${IMG_HERO_BG})`,
        }}
        aria-label="Hero"
      >
        <Container>
          <div className="hero-content" data-aos="fade-right">
            <h6 className="hero-subtitle2">{t("aboutUsNew.hero.subtitle2")}</h6>

            <h1>
              {t("aboutUsNew.hero.title")}
            </h1>
            <h2>{t("aboutUsNew.hero.tagline")} <span className="text-orange">{t("aboutUsNew.hero.tagline2")}</span> </h2>

            <p className="hero-subtitle">
              {t("aboutUsNew.hero.des1")}
              <br />
              {t("aboutUsNew.hero.des2")}
            </p>

            {/* ── CTA button ── */}
            <div className="d-flex gap-4">
              <a className="btn-orange hero-btn">
                {t("aboutUsNew.hero.btn1")} →
              </a>

              <Button className="hero-btn" variant="outline-warning">
                {t("aboutUsNew.hero.btn2")}
              </Button>
            </div>

            {/* ── Trust badges ── */}
            <div className="trust-badges mt-4">
              {trustBadges.map(({ icon, label1, label2 }, i) => (
                <div className="trust-badge" key={i}>
                  <div className="badge-icon" aria-hidden="true">
                    {icon}
                  </div>
                  <div>
                    <div dangerouslySetInnerHTML={{ __html: label1 }} />
                    <div>{label2}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>


      {/* ════════════════════════════════════════
          STATS SECTION
      ════════════════════════════════════════ */}
      <section className="stats-section stats-bar py-4 bg-white">
        <Container>
          <Row className="justify-content-between">
            {stats.map((item, index) => (
              <Col lg={2} md={4} sm={6} key={index}>
                <div className="d-flex align-items-center gap-2 borer-right-1">
                  <div className="stats-icon">
                    {item.icon}
                  </div>
                  <div className="stat-item">
                    <h4>{item.number}</h4>
                    <p>{item.title}</p>
                  </div>
                </div>
              </Col>
            ))}

          </Row>
        </Container>
      </section>
      

      {/* ════════════════════════════════════════
          STORY SECTION
      ════════════════════════════════════════ */}
      <section className="story-section py-5" data-aos="fade-up">
        <Container>
          <Row className="justify-content-between">
            <Col lg={4} data-aos="fade-right">
              <h6 className="hero-subtitle2 text-uppercase text-orange">{t("aboutUsNew.story.badge")}</h6>
              <h3 className="display-5 fw-bold">{t("aboutUsNew.story.title")}</h3>
              <p className="text-muted">
                {t("aboutUsNew.story.text1")}
              </p>
              <p className="text-orange fw-bold fs-5">
                {t("aboutUsNew.story.highlight")}
              </p>
              <p className="text-muted">
                {t("aboutUsNew.story.text2")}
              </p>
              <p className="text-muted">
                {t("aboutUsNew.story.text3")}
              </p>
            </Col>

            <Col lg={6} className="mt-4 mt-lg-0" data-aos="fade-left">
              <h6 className="hero-subtitle2 text-uppercase text-orange">{t("aboutUsNew.story.timeline.title")}</h6>
              <div className="timeline-wrapper">
                {timelineData.map((item, index) => (
                  <div 
                    key={index} 
                    className={`timeline-story-item ${index === timelineData.length - 1 ? 'last-item' : ''}`}
                  >
                    <div className="timeline-icon-wrapper">
                      <div className="timeline-icon">
                        {item.icon}
                      </div>
                      {index < timelineData.length - 1}
                    </div>
                    <div className="timeline-story-content d-flex gap-5">
                      <div className="timeline-year">{item.year}</div>
                      <div>
                        <h6 className="fw-bold">{item.title}</h6>
                        <p className="text-muted">{item.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ════════════════════════════════════════
          WHY SECTION
      ════════════════════════════════════════ */}
      <section className="py-5 bg-light border-top">
        <Container>
          <h3 className="text-center mb-5 fw-bold display-6">{t("aboutUsNew.whyChoose.title1")} <span className="text-orange">{t("aboutUsNew.whyChoose.title2")}</span> {t("aboutUsNew.whyChoose.title3")}</h3>
          <Row className="g-4">
            {whySec.map((item, i) => (
              <Col md={6} lg={4} key={i}>
                <Card className="h-100 border-0 shadow-sm text-center p-4 benefit-card">
                  <div className="icon-why-circle mx-auto">{item.icon}</div>
                  <h5>{item.title}</h5>
                  <p className="text-muted">{item.desc}</p>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ════════════════════════════════════════
          TEAM + VALUES SECTION
      ════════════════════════════════════════ */}
      <section className="team-section p-5">
          <Row className="g-4">
            {/* LEFT */}
            <Col lg={8}>
              <div className="team-wrapper">
                <div className="team-header">
                  <h2 className="text-dark">
                    {t("aboutUsNew.team.title")} <span>TransCiroX</span>
                  </h2>

                  <p>
                    {t("aboutUsNew.team.subtitle1")}
                    <br />
                    {t("aboutUsNew.team.subtitle2")}
                  </p>
                </div>

                <Row className="g-3 mt-2">
                  <Col md={6}>
                    <div className="member-card">
                      <img src={ZaherImg} alt="Zaher Rawas, Geschäftsführer und Gründer von TransCiroX" />
                      <div className="member-info">
                        <h5>Zaher Rawas</h5>
                        <span>
                          {t("aboutUsNew.team.member1")}
                        </span>
                        <p>
                          {t("aboutUsNew.team.descMember1")}
                        </p>
                        <div className="linkedin">
                          <FaLinkedinIn />
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="member-card">
                      <img src={RashadImg} alt="Rashad Alrojouleh, Geschäftsführer und Gründer von TransCiroX" />
                      <div className="member-info">
                        <h5>Rashad Alrojouleh</h5>
                        <span>
                          {t("aboutUsNew.team.member2")}
                        </span>
                        <p>
                          {t("aboutUsNew.team.descMember2")}
                        </p>
                        <div className="linkedin">
                          <FaLinkedinIn />
                        </div>

                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            {/* RIGHT */}
            <Col lg={4}>
              <div className="values-wrapper">
                <h2 className="text-orange">{t("aboutUsNew.values.title")}</h2>
                {valuesSec.map((item, i) => (
                  <div className="value-item" key={i}>
                    <div className="icon-why-circle">
                      {item.icon}
                    </div>
                    <div>
                      <h6>{item.title}</h6>
                      <p className="text-muted">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
      </section>


      {/* ════════════════════════════════════════
          TESTIMONIALS SECTION
      ════════════════════════════════════════ */}
      <section className="testimonials-about py-5" data-aos="fade-up">
        <Container>
          <h3 className="text-center fw-bold display-6 mb-5">
            {t("aboutUsNew.testimonials.title")}
          </h3>
          <Row className="g-4 justify-content-center">
            {testimonialsSec.map((item, index) => (
              <Col md={4} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="testimonial-card p-4 d-flex align-items-end">

                  <Col lg={10}>
                    <div className="testimonial-stars">
                      {[...Array(5)].map((_, i) => (
                        <FaStar key={i} className={i < item.stars ? "star-filled" : "star-empty"} />
                      ))}
                    </div>
                    <p className="testimonial-text">_{item.text}</p>
                    <p className="testimonial-author">- {item.author}</p>
                  </Col>

                  <Col lg={2} className="testimonial-icon">
                    {item.icon}
                  </Col>
                  
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      

      {/* ════════════════════════════════════════
          CTA SECTION
      ════════════════════════════════════════ */}
      <section className="cta-about-section" id="angebot" data-aos="fade-up">
        <Container>
          <Row className="align-items-center gy-4">

            <Col className="cta-text">
              <h2 className="text-dark">
                {t("aboutUsNew.cta.title1")} <span className="text-orange">{t("aboutUsNew.cta.title2")}</span>
              </h2>
              <p>
                {t("aboutUsNew.cta.text")}
              </p>
            </Col>

            <Col xs={12} sm="auto" className="cta-action text-center">
              <div className="d-flex gap-4">
                <a className="btn-orange hero-btn" onClick={() => navigate("/transport")}>
                  {t("aboutUsNew.cta.btn1")} →
                </a>

                <Button 
                  variant="outline-warning" 
                  className="hero-btn" 
                  onClick={() => {
                    localStorage.removeItem("bookingData");
                    navigate("/bookings");
                  }}
                >
                  {t("aboutUsNew.cta.btn2")}
                </Button>
              </div>

              {/* ── Trust badges ── */}
              <div className="trust-badges mt-4">
                {ctaBadges.map(({ icon, label1, label2 }, i) => (
                  <div className="trust-badge" key={i}>
                    <div className="badge-icon" aria-hidden="true">
                      {icon}
                    </div>
                    <div>
                      <div dangerouslySetInnerHTML={{ __html: label1 }} />
                      <div>{label2}</div>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
}